import LocalisedText from "../LocalisedText";
import { VideoIcon } from "../VideoIcon";
import { PerkButton, PerkButtonOptions } from "./PerkButton";

export class PerkAdButton extends PerkButton
{
    public adIcon: VideoIcon;
    
    constructor(opts: Partial<PerkButtonOptions> = {})
    {
        super(opts);

        this.adIcon = new VideoIcon();

        this.adIcon.scale.set(1.3);
        this.adIcon.x += 155;
        this.adIcon.y -= 50;
        this.adIcon.rotation = Math.PI * 20 / 180;

        this.icon.addChild(this.adIcon);

    }
    
    public setAdIconVisible(visible: boolean): void
    {
        this.adIcon.visible = visible;
    }
}
